import { fetchGet, fetchPost } from 'common';

const apiUri: string = process.env.REACT_APP_API_URI as string;

export const fetchStatesService = (usStateCode: string, bearerToken: string) =>
  fetchGet(`${apiUri}/dictionaries/states/${usStateCode}`, bearerToken);

export const fetchDriversService = (hobCode: string, bearerToken: string) =>
  fetchGet(`${apiUri}/dictionaries/drivers/${hobCode}`, bearerToken);

export const searchByAddressService = (body: any, bearerToken: string) =>
  fetchPost(`${apiUri}/properties/searchByAddress`, body, bearerToken);

export const searchByOwnerService = (body: any, bearerToken: string) =>
  fetchPost(`${apiUri}/properties/searchByOwner`, body, bearerToken);

export const searchByDriversService = (body: any, bearerToken: string) =>
  fetchPost(`${apiUri}/properties/searchByDrivers`, body, bearerToken);
